<ng-container *ngIf="displayForm">
    <section class="dynamic-form-container p-card">
        <div class="header-container">
            <!-- Logo Section -->
            <div class="logo-container">
                <img [src]="dynamicFormData?.image?.location" alt="Logo" class="form-logo" />
            </div>
        
            <!-- Header Section -->
            <div >
                <p class="form-title">{{ dynamicFormData?.name }}</p>
            </div>
        </div>
        <p-progressBar [value]="value"  [style]="{ height:'1rem'}" />
        <div class="p-m-4" [innerHTML]="rawHTML(dynamicFormData?.description)"></div>
        <hr />
        <div class="p-fluid p-mt-3">
            <ng-container *ngIf="columnDefinitions">
                <form [formGroup]="form">
                    <div class="p-grid p-gap-3">
                        <ng-container *ngFor="let column of columnDefinitions">
                            <div class="p-col-12 p-md-6">
                                <div class="p-field field-layout">
                                    <div class="p-mb-1">
                                        <label class="p-text-bold" [for]="column.name">{{ column.name | titlecase }}
                                            <span *ngIf="column.isRequired" style="color: red;">*</span>
                                            <i *ngIf="['FileUpload'].includes(column.formControlName)"
                                                class="pi pi-exclamation-circle p-ml-1" [escape]="false"
                                                [pTooltip]="multiLineTooltipFile" tooltipPosition="top"></i>
                                            <i *ngIf="['Picture'].includes(column.formControlName)"
                                                class="pi pi-exclamation-circle p-ml-1" [escape]="false"
                                                [pTooltip]="multiLineTooltipPicture" tooltipPosition="top"></i>
                                        </label>
                                    </div>
                                    <ng-container [ngSwitch]="column.formControlName">
                                        <input *ngSwitchCase="'InputBox'" pInputText [formControlName]="column.id"
                                            placeholder="Enter Text Input Only" />
                                        <p-autoComplete *ngSwitchCase="'DropDownList'" [formControlName]="column.id"
                                            [suggestions]="column.pickListValues"
                                            (completeMethod)="onDropdownSearch(column, $event.query)" [field]="'value'"
                                            [dropdown]="true" [placeholder]="'Search ' + column.name" [forceSelection]="true"
                                            [appendTo]="'body'" [disabled]="column.isLoading" [showClear]="true">
                                            <ng-template pTemplate="item" let-item>
                                                <span>{{ item }}</span>
                                            </ng-template>
                                        </p-autoComplete>
                                        <p-inputNumber *ngSwitchCase="'Number'" [formControlName]="column.id"
                                            placeholder="Enter Number Input Only"></p-inputNumber>
                                        <p-inputNumber *ngSwitchCase="'Decimal'" [formControlName]="column.id"
                                            mode="decimal" placeholder="Enter Decimal Input Only"
                                            [minFractionDigits]="1"
                                            [maxFractionDigits]="column?.maxLengthAfterDecimal ||10"></p-inputNumber>
                                        <p-inputNumber *ngSwitchCase="'Percentage'" [formControlName]="column.id"
                                            mode="decimal" placeholder="Enter Percentage Value"
                                            [minFractionDigits]="1" [maxFractionDigits]="10"></p-inputNumber>
                                        <p-calendar *ngSwitchCase="'DatePicker'" [formControlName]="column.id"
                                            [showIcon]="true" [readonlyInput]="true" [showButtonBar]="true"
                                            [placeholder]="'Please Select ' + column?.name" [appendTo]="'body'"
                                            [responsive]="true"></p-calendar>
                                        <p-calendar *ngSwitchCase="'DateTimePicker'" [formControlName]="column.id"
                                            [showIcon]="true" [readonlyInput]="true" [showButtonBar]="true"
                                            [placeholder]="'Please Select ' + column?.name" [showTime]="true"
                                            [hourFormat]="'12'" [appendTo]="'body'" [responsive]="true"
                                            class="responsive-calendar">
                                        </p-calendar>
                                        <!-- Barcode -->
                                        <ng-container *ngSwitchCase="'Barcode'">
                                            <input pInputText type="text" [formControlName]="column?.id"
                                                [placeholder]="'Please Enter ' + column?.name" />
                                        </ng-container>
                                        <!-- Multiple Dropdown -->
                                        <ng-container *ngSwitchCase="'MultipleDropDownList'">
                                            <p-multiSelect [options]="column?.pickListValues"
                                                [placeholder]="'Please Select ' + column?.name"
                                                [formControlName]="column.id" placeholder="Search..."
                                                (onFocus)="onDropdownSearch(column, $event.query)" appendTo="body"
                                                (onFilter)="onDropdownSearch(column, $event.query)" [multiple]="true"
                                                [filter]="true">
                                                <ng-template pTemplate="item" let-item>
                                                    <span>{{ item | shorten:60 }}</span>
                                                </ng-template>
                                            </p-multiSelect>
                                        </ng-container>
                                        <ng-container *ngSwitchCase="'CheckBox'">
                                            <ng-container *ngFor="let option of column.pickListValues; let i = index">
                                                <p-checkbox class="p-mr-2"
                                                    [formControl]="form.get(column.id).controls[i]" [binary]="true"
                                                    [label]="option" [value]="option">
                                                </p-checkbox>
                                            </ng-container>
                                        </ng-container>
                                        <!-- Radio Button -->
                                        <ng-container *ngSwitchCase="'RadioButton'">
                                            <ng-container *ngFor="let option of column?.pickListValues">
                                                <p-radioButton class="p-mr-2" [value]="option"
                                                    [formControlName]="column?.id" [label]="option">
                                                </p-radioButton>
                                            </ng-container>
                                        </ng-container>

                                        <!-- AutoNumber -->
                                        <ng-container *ngSwitchCase="'AutoNumber'">
                                            <input pInputText type="text" [formControlName]="column?.id"
                                                [disabled]="true" [readonly]="true" class="p-disabled"
                                                placeholder="This field value will be auto generated" />
                                        </ng-container>

                                        <!-- Multi-Line -->
                                        <ng-container *ngSwitchCase="'Multi-Line'">
                                            <textarea pInputTextarea type="text" [formControlName]="column?.id" rows="5"
                                                [placeholder]="'Please Enter ' + column?.name"></textarea>
                                        </ng-container>
                                        <!-- Email -->
                                        <ng-container *ngSwitchCase="'Email'">
                                            <input pInputText type="text" [formControlName]="column?.id"
                                                [placeholder]="'Please Enter ' + column?.name" />
                                            <small
                                                *ngIf="form.get(column.id).hasError('pattern') && form.get(column.id).touched"
                                                class="p-invalid">
                                                Please enter a valid {{ column.name }}.
                                            </small>
                                        </ng-container>

                                        <!-- Phone -->
                                        <ng-container *ngSwitchCase="'Phone'">
                                            <input pInputText type="text" [formControlName]="column?.id"
                                                [placeholder]="'Please Enter ' + column?.name" />
                                            <small
                                                *ngIf="form.get(column.id).hasError('pattern') && form.get(column.id).touched"
                                                class="p-invalid">
                                                Please enter a valid {{ column.name }}.
                                            </small>
                                        </ng-container>

                                        <!-- IPAddress -->
                                        <ng-container *ngSwitchCase="'IPAddress'">
                                            <input pInputText type="text" [formControlName]="column?.id"
                                                [placeholder]="'Please Enter ' + column?.name" />
                                            <small
                                                *ngIf="form.get(column.id).hasError('pattern') && form.get(column.id).touched"
                                                class="p-invalid">
                                                Please enter a valid {{ column.name }}.
                                            </small>
                                        </ng-container>

                                        <!-- URL -->
                                        <ng-container *ngSwitchCase="'URL'">
                                            <input pInputText type="text" [formControlName]="column?.id"
                                                placeholder="Enter URL with http/https" />
                                            <small
                                                *ngIf="form.get(column.id).hasError('pattern') && form.get(column.id).touched"
                                                class="p-invalid">
                                                Please enter a valid {{ column.name }}.
                                            </small>

                                        </ng-container>


                                        <!-- EncryptedText -->
                                        <ng-container *ngSwitchCase="'EncryptedText'">

                                            <p-iconField iconPosition="right">
                                                <p-inputIcon *ngIf="column?.show" styleClass="pi pi-eye"
                                                    (click)="column['show']=!column['show']" />
                                                <p-inputIcon *ngIf="!column?.show" styleClass="pi pi-eye-slash"
                                                    (click)="column['show']=!column['show']" />
                                                <input pInputText [formControlName]="column?.id" [type]="'text'"
                                                    [style]="!column['show'] ? '-webkit-text-security: disc;':''" />
                                            </p-iconField>
                                        </ng-container>

                                        <!-- Time -->
                                        <ng-container *ngSwitchCase="'Time'">
                                            <input pInputText type="time" [formControlName]="column?.id" />

                                        </ng-container>
                                        <!-- Currency -->
                                        <ng-container *ngSwitchCase="'Currency'">
                                            <p-inputNumber [formControlName]="column?.id" mode="decimal"
                                                placeholder="Enter Currency" [minFractionDigits]="0"
                                                [prefix]="column?.currencySymbol ? column?.currencySymbol.trim()+ ' ' : ''"
                                                [maxFractionDigits]="6" [step]="1">
                                            </p-inputNumber>
                                            <small
                                                *ngIf="form.get(column.id).hasError('pattern') && form.get(column.id).touched"
                                                class="p-invalid">
                                                Please enter a valid {{ column.name }}.
                                            </small>
                                        </ng-container>
                                        <!-- File Upload -->
                                        <ng-container *ngSwitchCase="'FileUpload'">
                                            <p-fileUpload customUpload="true" class="fupload" previewWidth="100"
                                                chooseLabel="Choose" [showUploadButton]="false"
                                                [showCancelButton]="false" multiple="multiple"
                                                (onSelect)="onCustomUpload($event, column, fileUpload, 'any')"
                                                #fileUpload>

                                                <ng-template pTemplate="content">
                                                    <ng-container
                                                        *ngFor="let file of form.get(column.id).value; let i = index;">
                                                        <div class="p-fileupload-row" *ngIf="file">
                                                            <!-- Download Button -->
                                                            <button pButton icon="fa fa-download"
                                                                (click)="downloadFile(file, $event, true)"
                                                                class="p-button-link p-px-0 p-py-0"
                                                                [pTooltip]="'Download: '+file?.fileName"
                                                                >
                                                            </button>

                                                            <div [pTooltip]="file?.fileName.substring(0, 30)" class="pointer" (click)="downloadFile(file, $event, false)"> {{
                                                                file?.fileName | shorten:30}} </div>
                                                            <!-- Remove Button -->
                                                            <div>
                                                                <button pButton type="button" icon="pi pi-times"
                                                                    (click)="deleteDocument(file, column, i)">
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </ng-template>
                                            </p-fileUpload>
                                        </ng-container>

                                        <!-- Picture -->
                                        <ng-container *ngSwitchCase="'Picture'">
                                            <p-fileUpload customUpload="true" class="fupload" previewWidth="100"
                                                chooseLabel="Choose" [showUploadButton]="false"
                                                [showCancelButton]="false" accept="image/*" multiple="multiple"
                                                (onSelect)="onCustomUpload($event, column, fileUpload, 'image')"
                                                #fileUpload>

                                                <ng-template pTemplate="content">
                                                    <ng-container
                                                        *ngFor="let file of form.get(column.id).value; let i = index;">
                                                        <div class="p-fileupload-row" *ngIf="file">
                                                            <!-- Download Button -->
                                                            <button pButton icon="fa fa-download"
                                                                (click)="downloadFile(file, $event, true)"
                                                                class="p-button-link p-px-0 p-py-0"
                                                                [pTooltip]="'Download: '+file?.fileName"
                                                                >
                                                            </button>

                                                            <div [pTooltip]="file?.fileName.substring(0, 30)"  class="pointer" (click)="downloadFile(file, $event, false)"> {{
                                                                file?.fileName | shorten:30 }} </div>
                                                            <!-- Remove Button -->
                                                            <div>
                                                                <button pButton type="button" icon="pi pi-times"
                                                                    (click)="deleteDocument(file, column, i)">
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </ng-container>
                                                </ng-template>
                                            </p-fileUpload>
                                        </ng-container>

                                        <!-- User Lookup -->
                                        <!-- <ng-container *ngSwitchCase="'UserLookup'">
                                                                                                            <p-dropdown [options]="usersList" [placeholder]="'Select ' + column.name"
                                                                                                                [filter]="true" [formControlName]="column.id" optionLabel="name" optionValue="id"
                                                                                                                appendTo="body" [showClear]="true">
                                                                                                            </p-dropdown>
                                                                                                        </ng-container> -->
                                        <!-- Ratings -->
                                        <ng-container *ngSwitchCase="'Rating'">
                                            <p-rating [cancel]="false" [formControlName]="column?.id"></p-rating>
                                            <!-- <span *ngIf="form.get(column?.id)?.value" 
                                            class="p-ml-2 btnBars" 
                                            pTooltip="Click here to clear rating"  
                                            tooltipPosition="top" 
                                            (click)="clearRating(column?.id, $event)">
                                              <i class="pi pi-times"></i>
                                            </span> -->
                                        </ng-container>
                                        <!-- Toggle Button -->
                                        <ng-container *ngSwitchCase="'ToggleButton'">
                                            <p-inputSwitch [formControlName]="column?.id" />
                                        </ng-container>
                                        <!-- RichText -->
                                        <ng-container *ngSwitchCase="'RichText'">
                                            <p-editor #editor [style]="{'height: auto, min-height':'100px'}"
                                                [formControlName]="column?.id" rows="5">
                                                <p-header>
                                                    <span class="ql-formats">
                                                        <select class="ql-size">
                                                            <option value="small">small</option>
                                                            <option selected></option>
                                                            <option value="large">large</option>
                                                            <option value="huge">huge</option>
                                                        </select>
                                                    </span>
                                                    <span class="ql-formats">
                                                        <button class="ql-bold" aria-label="Bold"></button>
                                                        <button class="ql-italic" aria-label="Italic"></button>
                                                        <button class="ql-underline" aria-label="Underline"></button>
                                                        <button class="ql-strike" aria-label="Strike"></button>
                                                    </span>
                                                    <span class="ql-formats">
                                                        <select title="Text Color" class="ql-color"></select>
                                                        <span class="ql-format-separator"></span>
                                                        <select title="Background Color" class="ql-background"></select>
                                                    </span>
                                                    <span class="ql-formats">
                                                        <button class="ql-list" value="ordered"></button>
                                                        <button class="ql-list" value="bullet"></button>
                                                        <select title="Text Alignment" class="ql-align">
                                                            <option selected>Gauche</option>
                                                            <option value="center" label="Center"></option>
                                                            <option value="right" label="Right"></option>
                                                            <option value="justify" label="Justify"></option>
                                                        </select>
                                                    </span>
                                                    <span class="ql-formats">
                                                        <button aria-label="Link" class="ql-link"></button>
                                                    </span>
                                                </p-header>
                                            </p-editor>
                                        </ng-container>
                                    </ng-container>
                                    <div *ngIf="form.get(column?.id)?.invalid && form.get(column?.id)?.touched">
                                        <small class="p-error" *ngIf="form.get(column.id)?.errors?.required">This field
                                            is required.</small>
                                    </div>
                                </div>
                            </div>
                        </ng-container>

                    </div>
                </form>
            </ng-container>
        </div>
        <div class="p-mt-3 p-text-right">
            <button pButton type="button" label="Submit" (click)="onSubmit()"
                [disabled]="isFormSubmitted"></button>
        </div>
    </section>
</ng-container>
<ng-container *ngIf="displaySubmissionMessage">
    <section class="dynamic-form-container  p-d-flex p-jc-center p-align-center p-py-4">
        <h5> {{submissionMessage}}</h5>
    </section>
</ng-container>
<ng-container *ngIf="displayAuthenticationModal">
    <!-- Authentication Modal Section -->
    <p-dialog header="Authentication Required" [style]="{width: '30vw'}" [(visible)]="displayAuthenticationModal"
        [closable]="false" [modal]="true">
        <div class="p-fluid">
            <div class="p-field">
                <label for="password">Password</label>
                <input type="password" pInputText [(ngModel)]="password" #passwordInput="ngModel"
                    [ngModelOptions]="{standalone: true}" minlength="4" maxlength="30" required />
                <div *ngIf="passwordInput?.invalid && passwordInput?.dirty">
                    <small class="p-error" *ngIf="passwordInput?.errors?.required">Password is required.</small>
                    <small class="p-error" *ngIf="passwordInput?.errors?.minlength">Password must be at least 4
                        characters.</small>
                    <small class="p-error" *ngIf="passwordInput?.errors?.maxlength">Password cannot exceed 30
                        characters.</small>
                </div>
            </div>
        </div>
        <div class="p-pt-3 p-d-flex p-jc-end">
            <button pButton label="Submit" (click)="onAuthenticationSubmit(password)"
                [disabled]="passwordInput?.invalid || isFormSubmitted"></button>
        </div>
    </p-dialog>
</ng-container>
<p-toast position="top-right" [baseZIndex]="1000000"></p-toast>
<p-confirmDialog key="dynamicExternalFormDialog" [style]="{ width: '20vw' }" [baseZIndex]="1000000"></p-confirmDialog>